<template>
  <div class="editable-field">
  <strong v-if="label">{{label}}:</strong>
  <component
    :is="componentType"
    ref="editableComponent"
    :contenteditable="isEditable"
    class="editable-component"
    @input="onInput"    
  ></component>
  <span class="edit-indicator">✎</span>
  </div>
</template>

<script>
export default {
  name: 'InlineEditor', // Name is now fixed to InlineEditor.
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    componentType: {
      type: String,
      default: "div",
    },
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.$refs.editableComponent.innerHTML = this.value;
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.innerHTML);
    },
  },
  watch: {
    value(newValue) {
      // This check prevents the cursor from jumping.
      if (this.$refs.editableComponent && newValue !== this.$refs.editableComponent.innerHTML) {
        this.$refs.editableComponent.innerHTML = newValue;
      }
    },
  },
};
</script>

<style scoped>
.editable-description {
  border: 1px solid #ccc;
  padding: 8px;
  min-height: 50px;
  outline: none;
}
.editable-description:focus {
  border-color: #1976d2;
}
.editable-field {
  position: relative;
  border: 1px solid transparent;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  margin-bottom: 15px;
}
.editable-field:hover {
  border-color: #dee2e6;
}
.edit-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  color: #6c757d;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.2s;
}
.editable-field:hover .edit-indicator {
  opacity: 1;
}
</style>